import React, { Component } from 'react';
import Cookie from 'js-cookie';
import MessageBox from '../UIComponents/MessageBox/MessageBox';
import LZString from 'lz-string';


class FedIDUrl extends Component {
  constructor(props) {
    super(props);
    const jsonData = Cookie.get('currentUser');
    let decompressedData = LZString.decompressFromBase64(jsonData);
    decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const user = JSON.parse(decompressedData);
    let userID = user['userId'];
    let givenName = user['givenName'];
    let designation = user['designation'];

    this.state = {
      title: props.title,
      userID,
      givenName,
      designation,
      modalOpen: false,
      message: '',
    };
  }
  handleClose = (e) => {
    this.setState({
      modalOpen: false,
      message: '',
    });
  };

  handleLogout = () => {
    this.setState({
      modalOpen: true,
      message: 'Are you sure you want to Signout?',
    });
  };

  componentDidMount() {}

  render() {
    const style = {
      display: 'block',
      marginTop: '15%',
      marginLeft: 'auto',
      marginRight: 'auto',
      textAlign: 'center',
      width: '50%',
      background: 'white',
      marginBottom: '35%',
    };
    const welHeader = {
      fontWeight: 'bold',
      fontSize: '300%',
      color: ' #ec6607',
      fontFamily: 'Roboto Condensed',
      fontStyle: 'italic',
    };
    const welHeader1 = {
      fontWeight: 'bold',
      fontSize: '200%',
      color: ' #0082c3',
      fontFamily: 'Roboto Condensed',
      fontStyle: 'italic',
    };
    const { userID, givenName, designation, modalOpen, message } = this.state;
    return (
      <div>
        {modalOpen ? (
          <MessageBox
            message={message}
            signout={true}
            onClose={this.handleClose}
          />
        ) : null}
        <div className='wrapper' style={{ background: 'white' }}>
          <header className='main-header'>
            {/* Logo */}
            <a href='#' className='logo'>
              {/* mini logo for sidebar mini 50x50 pixels */}
              <span className='logo-mini'>
                <img
                  src='/dist/img/decathlon_favicon.gif'
                  width={25}
                  alt='mini-logo'
                />
              </span>
              {/* logo for regular state and mobile devices */}
              <span className='logo-lg'>
                <img
                  src='/dist/img/logodecathwhite.png'
                  width={140}
                  alt='logo-decathlon'
                />
              </span>
            </a>
            {/* Header Navbar: style can be found in header.less */}
            <nav className='navbar navbar-static-top'>
              {/* Sidebar toggle button*/}
              <a
                href='#'
                className='sidebar-toggle'
                data-toggle='push-menu'
                role='button'
              >
                <span className='sr-only'>Toggle navigation</span>
              </a>
              <div style={{ height: '10px' }}></div>
              <span
                className='subheader-main'
                style={{ textTransform: 'capitalize' }}
              >
                {this.state.title}
              </span>
              <div className='navbar-custom-menu'>
                <ul className='nav navbar-nav'>
                  {/* Messages: style can be found in dropdown.less*/}

                  {/* User Account: style can be found in dropdown.less */}
                  <li className='dropdown user user-menu'>
                    <a
                      href='#'
                      className='dropdown-toggle'
                      data-toggle='dropdown'
                    >
                      <span className='hidden-xs'>
                        {givenName} <span className='caret'></span>
                      </span>
                    </a>
                    <ul className='dropdown-menu'>
                      {/* User image */}
                      <li className='user-header'>
                        <p>User Id - {userID}</p>
                        <p>Designation - {designation}</p>
                      </li>
                      {/* Menu Body */}

                      {/* Menu Footer*/}
                      <li className='user-footer'>
                        <div className='pull-right'>
                          <button
                            type='button'
                            className='btn btn-secondary deca-btn-yellow'
                            onClick={this.handleLogout}
                          >
                            Sign out
                          </button>
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </nav>
          </header>

          <div className='content-wrapper10'>
            <div className='align-center' style={style}>
              <h1 style={welHeader}>You don't have access to this portal.</h1>
              <p style={welHeader1}>
                Please contact your administrator to get access.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default FedIDUrl;
